import React, {useMemo, useRef, useState} from 'react';
import {Checkbox, Input, Select, Space, Switch} from "antd";
import {CheckOutlined, CloseCircleFilled, LoadingOutlined} from "@ant-design/icons"
import UserDiscipline from "../../models/UserDiscipline";
import {useAPI} from "../../config/API";
import {useAuth} from "../../providers/AuthProvider";
import LoadingSpinner from "../../components/LoadingSpinner";
import TalentLocationRadioSelect from "../../components/TalentLocationRadioSelect";
import Scrollbars from "react-custom-scrollbars";
import {useLocation} from "react-use";
const ExpLevelOptions = TB.map(laravel.talent_experience_levels, (config, value) => ({
    label: `${config?.level} (${config?.label})`,
    value,
    isDefault: config.level === 1,
    level: config.level
}));

const ImportanceLevelOptions = TB.map(laravel.importance_levels, (label, value) => ({
    label,
    value,
    isDefault: value === 2,
    level: value
}))

const FilterOptionsGroup = ({
                                className = '',
                                isDisabled,
                                selectedOptions,
                                name,
                                option,
                                onChange,
                                levelOptions,
                                onChangeImportance,
                                ...props
                            }) => {
    let optionValues = TB.map(option.options, 'value')
    let currentValues = TB.map(selectedOptions, 'value');
    let checkOptions = TB.filter(optionValues, value => currentValues.includes(value));
    let checked = TB.isArray(selectedOptions) && checkOptions?.length === optionValues?.length;


    return (
        <React.Fragment>
            <div key={`option-${TB.slugify(name)}-${TB.slugify(option.name)}`}
                 className={TB.mapClass("filter-option-form checkbox-options-container", {checked, [className]: true})}>
                <Checkbox
                    name={name}
                    id={"filter" + option.name}
                    required={false}
                    disabled={isDisabled}
                    indeterminate={!checked && checkOptions?.length > 0}
                    className="text-sm text-bold checkbox-options"
                    onChange={(e) => {
                        if (e.target.checked) {
                            let value = TB.uniqBy([...selectedOptions, ...option.options], 'value');
                            return onChange(value);
                        } else {
                            let value = TB.filter([...selectedOptions], item => !optionValues.includes(item.value));
                            return onChange(value);
                        }
                    }}
                    checked={checked}
                >
                    {option.name}

                </Checkbox>
            </div>


            <div className="checkbox-option-group">
                {TB.map(
                    option.options,
                    (cOption, cIndex) => {

                        let checked = TB.isArray(selectedOptions) ?
                            TB.map(selectedOptions, 'value').includes(cOption.value) :
                            !!selectedOptions[cOption.name];
                        let existing = currentValues[cOption.value];

                        let importanceValue = undefined;

                        if (levelOptions) {
                            importanceValue = TB.find(levelOptions, opt => {
                                if (existing?.importance) {
                                    return opt.level === existing?.importance
                                }
                                return opt.isDefault
                            });
                        }

                        let cName = (cOption.name || cOption.value);

                        let key = `cOption-${TB.slugify(cName)}`;
                        return (
                            <FilterOption
                                key={`option-${name}-${TB.slugify(cName)}-${importanceValue}`}
                                name={cName}
                                option={cOption}
                                isChecked={checked}
                                isDisabled={isDisabled}
                                levelOptions={levelOptions}
                                importanceValue={importanceValue}
                                onChange={() => onChange(cOption)}
                                onChangeImportance={value => {
                                    onChangeImportance(cOption, value)
                                }}
                            />
                        )
                    }
                )}
            </div>
        </React.Fragment>
    )
}
const FilterOption = ({
                          name,
                          option,
                          isChecked,
                          isDisabled,
                          importanceValue,
                          levelOptions,
                          onChange,
                          onChangeImportance,
                          ...props
                      }) => {
    const {pathname} = useLocation();

    const popupContainerID = location.pathname?.includes('add-talent') ? 'talent-pool-add-container' : 'browse-talent-container'

    return (
        <div className={TB.mapClass("filter-option-form", {checked: isChecked})}>
            <Checkbox
                name={name}
                id={"filter" + option.name}
                required={false}
                disabled={isDisabled}
                onChange={onChange}
                checked={isChecked}
                {...props}
            >
                {option.name}

            </Checkbox>

            {levelOptions && (
                <div className="filter-importance" onClick={(e) => {
                    if (!isChecked) {
                        e.stopPropagation();
                        e.preventDefault();
                        onChange(option)
                    }
                }}>
                    <Select
                        defaultValue={importanceValue}
                        className={TB.mapClass("importance-btn", {
                            disabled: !isChecked
                        })}
                        getPopupContainer={() => document.getElementById(popupContainerID)}
                        value={importanceValue}
                        size="small"
                        bordered={false}
                        onChange={onChangeImportance}
                        popupClassName="importance-select-popup"
                        placement="bottomRight"
                        options={levelOptions}
                    />
                </div>
            )}
        </div>
    )
}
const SearchTalentFilter = (props) => {

    const SearchInputRef = useRef(null);
    let loadTimeout;
    const [search, setSearch] = useState('');
    const [searchLoading, setSearchLoading] = useState(false);
    const [searchError, setSearchError] = useState(null);

    const [suggested, setSuggested] = useState(props.options || []);
    const [editingSelected, setEditingSelected] = useState(false);

    const onChange = (option) => {
        let value;
        if (TB.isArray(props.value)) {
            if (props.enableImportance && !option.importance) {
                option.importance = 2
            }
            value = [...props.value];
            value = TB.xorBy(value, [option], 'value');
            if (!value.length) {
                setEditingSelected(false)
            }
        } else if (TB.isObject(props.value)) {
            let value = {...props.value}

            value[option.name] = !!value[option.name]
        }

        return props.onChange(value)
    }

    const onChangeImportance = (option, importance) => {
        if (TB.isArray(props.value)) {
            let existing = TB.findIndex(props.value, ['value', option.value]);

            if (existing > -1) {
                let value = TB.set([...props.value], `[${existing}].importance`, importance);
                // console.log('BrowseTalentFilter @ onChangeImportance -> value', value);
                return props.onChange(value)
            } else if (TB.isArray(suggested)) {
                let existing = TB.findIndex(suggested, ['value', option.value]);

                if (existing > -1) {

                    // console.log('BrowseTalentFilter @ onChangeImportance -> selected', selected);
                    return;
                }
            }

            if (TB.isArray(props.options)) {
                let existing = TB.findIndex(props.options, ['value', option.value]);

                if (existing > -1) {
                    let options = TB.set([...props.options], `[${existing}].importance`, importance);
                    // console.log('BrowseTalentFilter @ onChangeImportance -> options', options);
                    return setSuggested(suggested)
                }
            }
        }
    }

    const getOptions = () => {

        if (TB.find(props.options, opt => !!opt.options)) {
            return TB.flatMap(props.options, 'options')
        }
        return props.options;
    }

    const selectAll = () => {
        if (props.label === 'Role') {
            return props.onChange(TB.flatten(TB.map(getOptions(), 'options')))
        }

        const mapOption = option => {
            if (props.enableImportance && !option.importance) {
                option.importance = 2
            }

            return option;
        }
        let values = TB.map(getOptions(), option => {
            if (option.options) {
                option.options = TB.map(option.options, opt => mapOption(opt))
            } else {
                option = mapOption(option);
            }

            return option;
        });

        return props.onChange(values)
    }

    const suggestedOptions = useMemo(() => {
        if (editingSelected) {
            return props.value;
        }
        if (props.searchEnabled && search?.length && !props.onSearchInput) {
            return suggested || props.options;
        }
        return props.options;
    }, [search, suggested, props.options, editingSelected])

    const SearchLoadIcon = props.searchLoading ? LoadingOutlined : CloseCircleFilled;
    let selectedValues = TB.keyBy(props.value || [], 'value');


    return (
        <div className="filter-button-dropdown">

            {props.value?.length > 0 && (
                <React.Fragment>
                    <div className="header">
                        <small className="text-bold flex-row flex-no-wrap flex py-2">
                            {!editingSelected && (
                                <span className={TB.mapClass("mr-auto text-dark px-2 text-uppercase", {
                                    "clickable text-primary": props.value?.length > 0,
                                    "opacity-50": !props.value?.length
                                })}
                                      onClick={async () => {

                                          await setSearch('')
                                          await props.onSearchInput?.();
                                          await setSuggested([])
                                          setEditingSelected(true)
                                      }}>
                                        Edit Selected
                                    </span>
                            )}
                            {props.value?.length > 0 && editingSelected && (
                                <span className="mr-auto text-primary clickable px-2 text-uppercase"
                                      onClick={() => setEditingSelected(false)}>
                                    Go Back
                                </span>
                            )}

                            {props.value?.length > 0 && (
                                <span className="ml-1 text-dark clickable px-2 text-uppercase"
                                      onClick={async () => {
                                          await setEditingSelected(false);
                                          props.onChange([])
                                      }}>
                                    Reset
                                </span>
                            )}

                            {/*        <span onClick={selectAll} className={TB.mapClass("ml-1 text-dark px-2 text-uppercase", {*/}
                            {/*            "clickable": props.options?.length && props.value?.length !== props.options?.length,*/}
                            {/*            "opacity-50": !props.options.length || props.value?.length === props.options?.length,*/}
                            {/*        })}>*/}
                            {/*    Select All*/}
                            {/*</span>*/}

                        </small>
                    </div>
                </React.Fragment>
            )}

            {(props.searchEnabled && !editingSelected) && (
                <div className="filter-search-input mb-3" key={TB.slugify(props.label) + '-search'}>

                    <Input
                        ref={SearchInputRef}
                        allowClear={{
                            clearIcon: <SearchLoadIcon style={{fontSize: 13, color: "#67676a"}}/>
                        }}
                        value={props.searchInput || search || ''}
                        placeholder="Start typing to search.."
                        onChange={async (e) => {
                            let inputValue = e.target.value;
                            if (props.onSearchInput) {
                                await props.onSearchInput(inputValue);
                            } else {
                                // console.log('searched', inputValue)
                                const searched = (item) => {
                                    return !inputValue?.length || item.trim().toLowerCase().indexOf(inputValue.trim().toLowerCase()) !== -1;
                                }
                                await setSearch(inputValue);

                                if (TB.find(props.options, opt => !!opt.options)) {
                                    let searchedOptions = TB.map([...props.options], option => {
                                        return {
                                            ...option,
                                            options: TB.filter([...option.options], childOption => {
                                                // console.log(childOption.name, searched(childOption.name))
                                                return searched(childOption.name)
                                            })
                                        }
                                    });
                                    searchedOptions = TB.filter(searchedOptions, option => option.options.length > 0);

                                    return setSuggested(searchedOptions)
                                } else {
                                    let searchedOptions = TB.filter([...props.options], option => {
                                        // console.log(option.name, searched(option.name))
                                        return searched(option.name)
                                    })

                                    return setSuggested(searchedOptions)
                                }

                            }
                        }}
                    />


                </div>
            )}


            {(!props.searchError && suggestedOptions?.length > 0) ? (
                <Scrollbars style={{width: '100%', height: getOptions()?.length > 15 ? 400 : 180}} className="filter-scroller">
                    {TB.map(suggestedOptions, (option, index) => {
                        let existing = selectedValues[option.value];

                        let checked = TB.isArray(props?.value) ? TB.map(props?.value, 'value')
                            .includes(option?.value) : !!props?.value?.[option?.name];

                        let importanceValue = undefined;

                        if (props.enableImportance) {
                            importanceValue = laravel.importance_levels[existing?.importance || 2];
                        } else if (props.enableExperience) {
                            importanceValue = laravel.talent_experience_levels[existing?.importance || 1]?.level;
                        }
                        let levelOptions = undefined;
                        if (props.enableImportance) {
                            levelOptions = ImportanceLevelOptions;
                        } else if (props.enableExperience) {
                            levelOptions = ExpLevelOptions;
                        }
                        if (option.options) {
                            // let optionValues = TB.map(option.options, 'value')
                            // let currentValues = TB.map(props.value, 'value');
                            // let checkOptions = TB.filter(optionValues, value => currentValues.includes(value));
                            // let checked = TB.isArray(props.value) && checkOptions?.length === optionValues?.length;
                            if (props.enableImportance) {
                                importanceValue = laravel.importance_levels[existing?.importance || 2];
                            } else if (props.enableExperience) {
                                importanceValue = laravel.talent_experience_levels[existing?.importance || 1]?.level;
                            }
                            return (
                                <FilterOptionsGroup
                                    key={`option-${option.name || option.value}-${index}`}
                                    option={option}
                                    name={TB.isArray(props.value) ? `${TB.slugify(props.label)}[]` : TB.slugify(option.name || option.value)}
                                    selectedOptions={props.value || []}
                                    onChange={selection => {
                                        if (TB.isArray(selection)) {
                                            return props.onChange(selection)
                                        }
                                        return onChange(selection)
                                    }}

                                    importanceValue={importanceValue}
                                    onChangeImportance={onChangeImportance}
                                    levelOptions={levelOptions}
                                />
                            )

                        }


                        let cName = option.name || option.value;

                        return (
                            <FilterOption
                                key={`option-${cName}-${index}-${importanceValue}`}
                                name={cName}
                                option={option}
                                isChecked={checked}
                                levelOptions={levelOptions}
                                importanceValue={importanceValue}
                                onChange={() => onChange(option)}
                                onChangeImportance={value => {
                                    onChangeImportance(option, value)
                                }}
                            />
                        )
                    })}
                </Scrollbars>
            ) : (
                <div className="filter-option-form checked">
                    <div className="text-xs">
                        <p className="text-danger mb-3">
                            {props.searchError || '0 results found. Try editing your search.'}
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
};



const TalentPoolsFilter = ({value, isDisabled, onChange = () => true, ...props}) => {

    const {auth} = useAuth();
    const [isAllChecked, setIsAllChecked] = useState(
        !value.hired &&
        !value?.favorited &&
        !value?.invited &&
        !value.pool_ids?.length
    );

    const getParamForDefaultPool = (poolId) => {
        switch (poolId) {
            case -1:
                return 'favorited'
            case -2:
                return 'hired'
            case -3:
                return 'invited'
            default:
                return false
        }
    }
    const {
        data: talentPoolsData,
        isFetching
    } = useAPI(['fetchTalentPools', {clientId: auth.clientOrg?.()?.id}], {
        enabled: !!auth && auth?.hasClientOrg?.(),
        select: data => {
            return TB.filter(TB.map(data, item => {
                return {
                    ...item,
                    name: `${item.name} (${item.talent_users_count})`,
                    value: item.id > 0 ? item.id : getParamForDefaultPool(item.id)
                }
            }), pool => pool.talent_users_count > 0)
        }
    })

    const selectedDefaultPools = TB.filter(talentPoolsData || [], pool => pool.id > 0 ? (value?.pool_ids || []).includes(pool.id) : value[pool.value]);

    const selectedPools = TB.filter(talentPoolsData || [], pool => (value?.pool_ids || []).includes(pool.id));

    const onChangePool = async (selection) => {
        console.log('onChangePool', selection)
        if (TB.isArray(selection)) {
            return onChange({pool_ids: TB.map(selection, 'id')});
        } else {
            let pools = [...(value?.pool_ids || [])];
            pools = TB.xor(pools, [selection.id]);
            if (isAllChecked && pools?.length) {
                await setIsAllChecked(false)
            }
            return onChange({pool_ids: pools})
        }
    }
    const onChangeDefaultPool = async (selection) => {
        console.log('onChangeDefaultPool', selection)
        if (selection?.id > 0) {
            return onChangePool(selection)
        }
        let updates = {};
        if (TB.isArray(selection)) {
            if (selection.length) {
                TB.map(selection, pool => {
                    updates[pool.value] = true;
                })
            } else {
                updates = {hired: 0, favorited: 0, invited: 0}
            }

        } else {
            let selectedDefaultPoolsIds = TB.map(selectedDefaultPools, 'value');
            updates[selection.value] = selectedDefaultPoolsIds.includes(selection.value) ? 0 : 1
        }
        if (updates.hired || updates.favorited || updates.invited) {
            await setIsAllChecked(false)
        }
        return onChange(updates)
    }

    const groupedTalentPools = useMemo(() => {

        if (isFetching || !talentPoolsData) {
            return false;
        }
        return {
            defaultPoolOptions: {
                name: 'General Talent Pools',
                options: TB.filter(talentPoolsData || [], {is_default: true})
            },
            personalPoolOptions: {
                name: 'Personal Pools',
                options: TB.filter(talentPoolsData || [], {'is_default': false, 'is_personal': true})
            },
            companyPoolOptions: {
                name: 'Company Pools',
                options: TB.filter(talentPoolsData || [], {'is_default': false, 'is_personal': false})
            },
        }

    }, [isFetching, talentPoolsData])

    // if (isFetching) {
    //     return
    // }
    // if (!talentPoolsData?.length) {
    //     return null;
    // }
    return (
        <React.Fragment>
            <div className="search-talent-sidebar">
                <div className="criteria-filters">


                    <div className="filter-button-dropdown">

                        {isFetching ? (
                            <div className="flex-center-column py-4 mt-4">
                                <LoadingSpinner/>
                                <p className="text-sm text-center my-2">
                                    Getting options..
                                </p>

                            </div>
                        ) : (
                            <React.Fragment>
                                <div
                                    className="mt-2 mb-4 inline-flex self-end flex-row items-center gap-1.5 justify-end">
                                    <p className="text-sm text-bold text-dark">
                                        All Talent
                                    </p>
                                    <Switch
                                        size="default"
                                        className={isAllChecked ? 'pointer-events-none cursor-default' : ''}
                                        checked={isAllChecked}
                                        checkedChildren={<CheckOutlined/>}
                                        disabled={false}
                                        onChange={async (checked, e) => {
                                            if (!isAllChecked) {
                                                let updates = {hired: 0, favorited: 0, invited: 0, pool_ids: []};
                                                await onChange(updates)
                                            }
                                            setIsAllChecked(!isAllChecked)
                                        }}
                                    />

                                </div>
                                {groupedTalentPools?.defaultPoolOptions?.options?.length > 0 && (
                                    <FilterOptionsGroup
                                        option={groupedTalentPools.defaultPoolOptions}
                                        name="default-pools"
                                        className={isAllChecked ? 'disabled' : ''}
                                        selectedOptions={selectedDefaultPools}
                                        onChange={onChangeDefaultPool}
                                    />
                                )}
                                {groupedTalentPools?.personalPoolOptions?.options?.length > 0 && (
                                    <FilterOptionsGroup
                                        option={groupedTalentPools.personalPoolOptions}
                                        name="personal-pools"
                                        className={isAllChecked ? 'disabled' : ''}
                                        selectedOptions={selectedPools}
                                        onChange={onChangePool}
                                    />
                                )}

                                {groupedTalentPools?.companyPoolOptions?.options?.length > 0 && (
                                    <FilterOptionsGroup
                                        option={groupedTalentPools.companyPoolOptions}
                                        name="personal-pools"
                                        className={isAllChecked ? 'disabled' : ''}
                                        selectedOptions={selectedPools}
                                        onChange={onChangePool}
                                    />
                                )}
                            </React.Fragment>
                        )}
                    </div>


                </div>
            </div>

        </React.Fragment>
    )
}


const DisciplinesFilter = ({value = [], onChange = () => true, options = [], searchEnabled, ...props}) => {

    return (
        <div className="search-talent-sidebar">
            <div className="criteria-filters">
                <SearchTalentFilter
                    value={value}
                    options={options}
                    label="Roles"
                    searchType={searchEnabled ? "disciplines" : undefined}
                    searchEnabled={searchEnabled}
                    onChange={onChange}
                />
            </div>
        </div>
    )
}


const RoleTemplatesFilter = ({value = [], onChange = () => true, options = [], searchEnabled, ...props}) => {

    return (
        <div className="search-talent-sidebar">
            <div className="criteria-filters">
                <SearchTalentFilter
                    value={value}
                    options={options}
                    label="Roles"
                    searchEnabled={false}
                    onChange={onChange}
                />
            </div>
        </div>
    )
}

const ProjectTemplatesFilter = ({
                                    value = [],
                                    onChange = () => true,
                                    options = [],
                                    searchEnabled,
                                    ...props
}) => {

    return (
        <div className="search-talent-sidebar">
            <div className="criteria-filters">
                <SearchTalentFilter
                    value={value}
                    options={options}
                    label="Project Types"
                    searchType={searchEnabled ? "projectTemplates" : undefined}
                    searchEnabled={searchEnabled}
                    onChange={onChange}
                />
            </div>
        </div>
    )
}

const PartnerProgramsFilter = ({
                          onChange = () => true,
                          enableImportance,
                          value, options = [],
                          searchEnabled = true,
                          ...props
                      }) => {

    const [suggested, setSuggested] = useState([]);
    const [search, setSearch] = useState('')

    const {
        data: programData,
        isFetching,
        error
    } = useAPI(['fetchPartnerPrograms', {search}], {
        enabled: searchEnabled && search?.length > 0,
        onSuccess: response => {
            let suggest = TB.map(response, option => {
                let programs = option.programs;

                option.programs = TB.map(programs, program => TB.pick(program, ['id', 'name', 'display_order']))
                option.value = option.id;

                return {
                    ...option,
                    options: option.programs.map(program => {
                        return {
                            ...program,
                            value: program.id
                        }
                    })
                }
            })
            setSuggested(suggest)
        },
        onError: e => {
            setSuggested(e);
        }
    })
    const programOptions = useMemo(() => {
        let programs = options;
        if (search?.length && suggested?.length) {
            programs = suggested || [];
        }

        return programs;
    }, [suggested, isFetching, search]);

    const searchError = useMemo(() => {
        if (isFetching || !search?.length) return false;

        if (error) return error;

        if (!suggested?.length) {
            return "0 results found. Try editing your search."
        }

        return false
    }, [search, suggested, isFetching, error])

    return (
        <div className="search-talent-sidebar">
            <div className="criteria-filters">
                <SearchTalentFilter
                    value={value}
                    options={TB.isArray(programOptions) ? programOptions : undefined}
                    searchError={searchError}
                    searchLoading={isFetching}
                    searchInput={searchEnabled ? search : undefined}
                    onSearchInput={searchEnabled ? searchInput => {
                        // console.log('onsearchinput', searchInput);
                        if (!searchInput?.length) {
                            setSuggested([]);
                        }
                        setSearch(searchInput)
                    } : undefined}
                    label="Partner programs"
                    searchType={searchEnabled ? "programs" : undefined}
                    enableImportance={false}
                    searchEnabled={searchEnabled}
                    onChange={onChange}
                />

            </div>
        </div>
    )
}

const ServiceTagsFilter = ({
                                   onChange = () => true,
                                   enableImportance,
                                   value, options = [],
                                   searchEnabled = true,
                                   ...props
                               }) => {

    const [suggested, setSuggested] = useState([]);
    const [search, setSearch] = useState('')

    const {
        data: serviceTagData,
        isFetching,
        error
    } = useAPI(['fetchServiceOfferingTags', {search}], {
        enabled: searchEnabled && search?.length > 0,
        onSuccess: response => {
            let suggest = TB.map(response, option => {
                let serviceTags = option.service_tags;

                option.service_tags = TB.map(serviceTags, service => TB.pick(service, ['id', 'name', 'display_order']))
                option.value = option.id;

                return {
                    ...option,
                    options: option.service_tags.map(serviceTag => {
                        return {
                            ...serviceTag,
                            value: serviceTag.id
                        }
                    })
                }
            })
            setSuggested(suggest)
        },
        onError: e => {
            setSuggested(e);
        }
    })
    const serviceTagOptions = useMemo(() => {
        let serviceTags = options;
        if (search?.length && suggested?.length) {
            serviceTags = suggested || [];
        }

        return serviceTags;
    }, [suggested, isFetching, search]);

    const searchError = useMemo(() => {
        if (isFetching || !search?.length) return false;

        if (error) return error;

        if (!suggested?.length) {
            return "0 results found. Try editing your search."
        }

        return false
    }, [search, suggested, isFetching, error])

    return (
        <div className="search-talent-sidebar">
            <div className="criteria-filters">
                <SearchTalentFilter
                    value={value}
                    options={TB.isArray(serviceTagOptions) ? serviceTagOptions : undefined}
                    searchError={searchError}
                    searchLoading={isFetching}
                    searchInput={searchEnabled ? search : undefined}
                    onSearchInput={searchEnabled ? searchInput => {
                        // console.log('onsearchinput', searchInput);
                        if (!searchInput?.length) {
                            setSuggested([]);
                        }
                        setSearch(searchInput)
                    } : undefined}
                    label="Services"
                    searchType={searchEnabled ? "service_tags" : undefined}
                    enableImportance={false}
                    searchEnabled={searchEnabled}
                    onChange={onChange}
                />

            </div>
        </div>
    )
}
const SkillsFilter = ({
                          selectedDisciplineIds = [],
                          onChange = () => true,
                          enableImportance,
                          value, options = [],
                          searchEnabled = true,
                          ...props
}) => {

    const [suggested, setSuggested] = useState([]);
    const [search, setSearch] = useState('')

    const {
        data: skillData,
        isFetching,
        error
    } = useAPI(['searchTalentSkills', {search}], {
        enabled: searchEnabled && search?.length > 0,
        onSuccess: response => {
            setSuggested(response)
        },
        onError: e => {
            setSuggested(e);
        }
    })
    const skillOptions = useMemo(() => {
        let skills = options;
        if (search?.length && suggested?.length) {
            skills = suggested || [];
        } else if (selectedDisciplineIds?.length) {
            skills = UserDiscipline.skillsForDisciplines(selectedDisciplineIds) || [];
        }

        skills = TB.map(TB.take(skills, 70), skill => ({...skill, value: skill.id}))

        // append already selected skills to bottom of list if missing from suggested default skills for selected disciplines
        if (!search?.length && selectedDisciplineIds?.length) {
            let differenceBy = TB.differenceBy(value, skills, 'id');
            if (differenceBy?.length) {
                skills = [...skills, ...differenceBy];
            }
        }

        return skills;
    }, [selectedDisciplineIds, suggested, isFetching, search]);

    const searchError = useMemo(() => {
        if (isFetching || !search?.length) return false;

        if (error) return error;

        if (!suggested?.length) {
            return "0 results found. Try editing your search."
        }

        return false
    }, [search, suggested, isFetching, error])

    return (
        <div className="search-talent-sidebar">
            <div className="criteria-filters">
                <SearchTalentFilter
                    value={value}
                    options={TB.isArray(skillOptions) ? skillOptions : undefined}
                    searchError={searchError}
                    searchLoading={isFetching}
                    searchInput={searchEnabled ? search : undefined}
                    onSearchInput={searchEnabled ? searchInput => {
                        // console.log('onsearchinput', searchInput);
                        if (!searchInput?.length) {
                            setSuggested([]);
                        }
                        setSearch(searchInput)
                    } : undefined}
                    label="Skill"
                    searchType={searchEnabled ? "skills" : undefined}
                    enableImportance={enableImportance}
                    searchEnabled={searchEnabled}
                    onChange={onChange}
                />

            </div>
        </div>
    )
}

const IndustriesFilter = ({value = [], onChange = () => true, enableImportance, options = [], searchEnabled = true, ...props}) => {

    return (
        <div className="search-talent-sidebar">
            <div className="criteria-filters">
                <SearchTalentFilter
                    value={value}
                    options={options}
                    label="Industries"
                    searchType={searchEnabled ? "industries" : undefined}
                    enableImportance={enableImportance}
                    searchEnabled={searchEnabled}
                    onChange={onChange}
                />
            </div>
        </div>
    )
}


const BrandsFilter = ({value = [], onChange = () => true, enableImportance, options = [], searchEnabled = true, ...props}) => {
    const [suggested, setSuggested] = useState([]);
    const [search, setSearch] = useState('')

    const {
        data: brandData,
        isFetching,
        error
    } = useAPI(['searchTalentBrands', search], {
        enabled: searchEnabled && search?.length > 0,
        onSuccess: response => {
            setSuggested(response)
        },
        onError: e => {
            setSuggested(e);
        }
    })
    const brandOptions = useMemo(() => {
        let brands = options;
        if (search?.length && suggested?.length) {
            brands = suggested || [];
        }

        brands = TB.map(TB.take(brands, 70), brand => ({...brand, value: brand.id}))

        // append already selected skills to bottom of list if missing from suggested default skills for selected disciplines
        if (!search?.length) {
            let differenceBy = TB.differenceBy(value, brands, 'id');
            if (differenceBy?.length) {
                brands = [...brands, ...differenceBy];
            }
        }

        return brands;
    }, [suggested, isFetching, search]);

    const searchError = useMemo(() => {
        if (isFetching || !search?.length) return false;

        if (error) return error;

        if (!suggested?.length) {
            return "0 results found. Try editing your search."
        }

        return false
    }, [search, suggested, isFetching, error])

    return (
        <div className="search-talent-sidebar">
            <div className="criteria-filters">
                <SearchTalentFilter
                    value={value}
                    label="Brands"
                    options={TB.isArray(brandOptions) ? brandOptions : undefined}
                    searchError={searchError}
                    searchLoading={isFetching}
                    searchInput={searchEnabled ? search : undefined}
                    onSearchInput={searchEnabled ? searchInput => {
                        // console.log('onsearchinput', searchInput);
                        if (!searchInput?.length) {
                            setSuggested([]);
                        }
                        setSearch(searchInput)
                    } : undefined}
                    searchType={searchEnabled ? "brands" : undefined}
                    enableImportance={false}
                    enableExperience={false}
                    searchEnabled={searchEnabled}
                    onChange={onChange}
                />
            </div>
        </div>
    )
}

const ExperienceSelectFilter = ({value = {}, onChange = () => true, options = [], ...props}) => {

    // console.log('ExperienceSelectFilter', experienceLevels);
    return (
        <div className="search-talent-sidebar">
            <div className="criteria-filters">
                <div className="filter-custom-options">
                    <Space direction="vertical">
                        {options.map(exp => (
                            <Checkbox
                                key={exp.label}
                                checked={value[exp.value] === true}
                                onChange={e => {
                                    onChange({
                                        ...value,
                                        [exp.value]: e.target.checked
                                    })
                                }}
                                className="text-xs">
                                {exp.level} ({exp.label})
                            </Checkbox>
                        ))}
                    </Space>
                </div>
            </div>
        </div>
    )
}


const AgencySizeSelectFilter = ({value = {}, onChange = () => true, ...props}) => {
    const options = TB.map(laravel.client_sizes, (label, value) => {
        return {
            label, value
        }
    })

    // console.log('ExperienceSelectFilter', experienceLevels);
    return (
        <div className="search-talent-sidebar">
            <div className="criteria-filters">
                <div className="filter-custom-options">
                    <Space direction="vertical">
                        {options.map(({label, value:cvalue}) => (
                            <Checkbox
                                key={label}
                                checked={value[cvalue] === true || value[cvalue] === 1}
                                onChange={e => {
                                    onChange({
                                        ...value,
                                        [cvalue]: e.target.checked
                                    })
                                }}
                                className="text-xs">
                                {label}
                            </Checkbox>
                        ))}
                    </Space>
                </div>
            </div>
        </div>
    )
}

const TalentLocationFilter = ({value, regions = [], isDisabled, proximity, onChange = () => true, ...props}) => {
    return (
        <div className="search-talent-sidebar">
            <div className="criteria-filters">
                <div className="filter-custom-options">
                    <TalentLocationRadioSelect
                        value={value}
                        proximity={proximity}
                        regions={regions}
                        onChange={onChange}/>
                </div>
            </div>
        </div>
    )
}

export default SearchTalentFilter;

export {
    TalentLocationFilter,
    SkillsFilter,
    PartnerProgramsFilter,
    ServiceTagsFilter,
    DisciplinesFilter,
    RoleTemplatesFilter,
    BrandsFilter,
    ProjectTemplatesFilter,
    IndustriesFilter,
    ExperienceSelectFilter,
    AgencySizeSelectFilter,
    TalentPoolsFilter
}